import {
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FormHelperService } from '../../../helpers/form-helper.service';
import { DraftFacade } from '@classifieds-sell/state';
import { PropertyInformationSectionComponent } from '../property-information-section/property-information-section.component';

@Component({
    selector: 'property-features-section',
    templateUrl: './property-features-section.component.html',
    styleUrls: ['./property-features-section.component.scss']
})
export class PropertyFeaturesSectionComponent
    extends PropertyInformationSectionComponent
    implements OnInit, OnDestroy {

    @ViewChild('propertyFeaturesSectionForm')
    propertyFeaturesSectionForm: NgForm;

    sideCardIcon = '/sell/property/assets/property-ui/list.svg';
    sideCardHeading = 'Rentals must comply with the Healthy Homes Standards';
    sideCardDescription = 'The Healthy Homes Standards (2019) requires all rentals in New Zealand to meet the minimum standards for heating, insulation, ventilation and more. Properties that do not meet these standards cannot be listed on Trade Me.';
    sideCardCallToActionText = 'About the healthy homes standards';
    sideCardCallToActionLink = 'https://www.tenancy.govt.nz/healthy-homes';

    constructor(
        draftFacade: DraftFacade,
        route: ActivatedRoute,
        changeDetectorRef: ChangeDetectorRef,
        formHelperService: FormHelperService
    ) {
        super(draftFacade, route, changeDetectorRef, formHelperService);
    }

    isValid(): boolean {
        this.formHelperService.validate(this.propertyFeaturesSectionForm);
        return this.propertyFeaturesSectionForm.form.valid;
    }

    dirty(): boolean {
        return this.propertyFeaturesSectionForm.form.dirty;
    }
}
